import { Box, Typography } from '@mui/material';
import React from 'react';

export function MarketplaceOrderDetail({ row }) {
  if (!row?.orderItems?.length) return null;

  return (
    <Box display="flex" flexWrap="wrap" width="60%" marginLeft="3rem" marginY="1rem">
      {row.orderItems.map((item) => (
        <Box
          key={item.id}
          width="100%"
          borderBottom="1px solid lightgray"
          paddingY=".4rem"
          display="flex"
          flexWrap="wrap"
        >
          <Box display="flex" width="100%" justifyContent="space-between">
            <Typography fontWeight="bold" fontSize=".875rem">{item.itemName}</Typography>
            <Typography sx={{ marginRight: "1rem",  fontSize: ".875rem" }}>
              x{item.quantity} &nbsp; ${item.price >= 0 ? (item.price).toFixed(2) : "0.00"}
            </Typography>
          </Box>
          <Typography variant="caption" color="text.secondary" width="100%">
            {[item.category, item.subcategory].filter(Boolean).join(' / ')}
          </Typography>
          {!!item.note && (
            <Typography variant="caption" width="100%" fontStyle="italic" pl={1}>
              Note: {item.note}
            </Typography>
          )}
          {item.orderSubItems?.map((sub) => (
            <Typography key={sub.id} variant="caption" width="100%" pl={1}>
              + {sub.itemName} x{sub.quantity}
              {sub.price > 0 ? ` ($${sub.price.toFixed(2)})` : ''}
            </Typography>
          ))}
        </Box>
      ))}
    </Box>
  );
}
